import * as React from "react";
import * as _ from "lodash";
import { Link } from "react-router-dom";
import { Icon, Modal, Button, Table } from "antd";

import { FileStatus as FileStatusDef, ReportFileStatus } from "../../constants";

const STATUS_TO_ICON: any = {
  pending: "clock-circle",
  running: "loading",
  failure: "exclamation-circle",
  system_failure: "exclamation-circle",
  success: "check-circle"
};

class FileStatus extends React.Component<FileStatusDef, any> {
  state = {
    statusModal: false
  };

  toggleModal() {
    this.setState(prevState => ({ statusModal: !prevState.statusModal }));
  }

  renderStatusLine(name: string, rfs: ReportFileStatus) {
    return (
      <tr>
        <td className="file-status-name">{name}</td>
        <td className="file-status">
          <Icon type={STATUS_TO_ICON[rfs.status]} className={rfs.status} />
          {_.upperFirst(rfs.status)}
        </td>
      </tr>
    );
  }

  renderSystemWarning() {
    if (this.props.reportFile.status === "system_failure") {
      return (
        <div className="file-status-notice">
          <Icon type="exclamation-circle" className="system_failure" />
          <p className="notice">
            We are experiencing technical difficulties causing delays in
            reporting. Once these issues have been resolved your reports will be
            delivered to their destinations automatically. We apologize for the
            delay and any inconveniences it may have caused.
          </p>
        </div>
      );
    } else if (this.props.reportFile.status === "pending") {
      return (
        <div className="file-status-notice">
          <Icon type="clock-circle" className="pending" />
          <p className="notice">Your file is being generated and delivered.</p>
        </div>
      );
    } else if (this.props.reportFile.status === "failure") {
      return (
        <div className="file-status-notice">
          <Icon type="exclamation-circle" className="system_failure" />
          <p className="notice">
            Please check that your delivery endpoints are defined properly and
            running.
          </p>
        </div>
      );
    }
  }

  getEditURL() {
    let location = {
      pathname: this.props.editLink,
      state: { step: 2 }
    };

    return location;
  }

  renderModal() {
    let ftp = _.find(this.props.reportFile.report_statuses, {
      process: "ftp_distributor"
    });
    let sftp = _.find(this.props.reportFile.report_statuses, {
      process: "sftp_distributor"
    });
    let email = _.find(this.props.reportFile.report_statuses, {
      process: "email_distributor"
    });

    return (
      <div className="status-table">
        {this.renderSystemWarning()}
        <table>
          <thead>
            <tr>
              <th>Process</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {ftp ? this.renderStatusLine("FTP", ftp) : null}
            {sftp ? this.renderStatusLine("Secure FTP", sftp) : null}
            {email ? this.renderStatusLine("Email", email) : null}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const status = this.props.reportFile.status;
    return (
      <div className="file-status">
        <Icon type={STATUS_TO_ICON[status]} className={status} />

        <span className="status">
          {_.capitalize(this.props.reportFile.status_display)}
        </span>

        <span className="see-details" onClick={this.toggleModal.bind(this)}>
          See Details
        </span>

        <Modal
          title={this.props.reportFile.name}
          visible={this.state.statusModal}
          wrapClassName="view-report-files"
          closable={false}
          footer={[
            <Button
              key="close"
              className="ant-btn-secondary"
              onClick={this.toggleModal.bind(this)}
            >
              Close
            </Button>,
            <Link to={this.getEditURL()}>
              <Button key="edit" type="primary">
                Edit
              </Button>
            </Link>
          ]}
        >
          {this.renderModal()}
        </Modal>
      </div>
    );
  }
}

export default FileStatus;



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReportFiles/FileStatus.tsx